<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
  >
    <path d="M6.24664 5C6.24664 3.89543 7.14207 3 8.24664 3C9.35121 3 10.2466 3.89543 10.2466 5C10.2466 6.10457 9.35121 7 8.24664 7C7.14207 7 6.24664 6.10457 6.24664 5ZM5.74662 8L10.7466 8C11.5751 8 12.2466 8.67157 12.2466 9.5C12.2466 10.6161 11.7877 11.5103 11.0345 12.1148C10.2932 12.7098 9.29972 13 8.24664 13C7.19357 13 6.20006 12.7098 5.45879 12.1148C4.70561 11.5103 4.24664 10.6161 4.24664 9.5C4.24664 8.67161 4.91821 8 5.74662 8ZM8.24664 0C3.82837 0 0.246643 3.58172 0.246643 8C0.246643 12.4183 3.82837 16 8.24664 16C12.6649 16 16.2466 12.4183 16.2466 8C16.2466 3.58172 12.6649 0 8.24664 0ZM1.24664 8C1.24664 4.13401 4.38065 1 8.24664 1C12.1126 1 15.2466 4.13401 15.2466 8C15.2466 11.866 12.1126 15 8.24664 15C4.38065 15 1.24664 11.866 1.24664 8Z" />
  </svg>
</template>
